
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M15.5 13.5C15.5 15.5 13 17 13 18.5H11C11 17 8.5 15.5 8.5 13.5C8.5 11.57 10.07 10 12 10C13.93 10 15.5 11.57 15.5 13.5ZM13 19.5H11V20C11 20.55 11.45 21 12 21C12.55 21 13 20.55 13 20V19.5ZM19 13C19 14.39 18.59 15.69 17.88 16.78C17.63 17.17 17.69 17.69 18.02 18.02C18.46 18.46 19.22 18.4 19.56 17.87C20.47 16.47 21 14.8 21 13C21 10.64 20.09 8.49003 18.6 6.88003C18.21 6.46003 17.55 6.45003 17.15 6.85003C16.77 7.23003 16.77 7.84003 17.13 8.24003C18.29 9.49003 19 11.16 19 13ZM15.65 4.65003L12.86 1.86003C12.54 1.54003 12 1.76003 12 2.21003V4.00003C7.03 4.00003 3 8.03003 3 13C3 14.8 3.53 16.47 4.44 17.88C4.78 18.41 5.54 18.47 5.98 18.03C6.31 17.7 6.37 17.19 6.12 16.8C4.73 14.65 4.48 11.7 6.25 8.80003C7.45 6.85003 9.71 5.81003 12 6.00003V7.79003C12 8.24003 12.54 8.46003 12.85 8.14003L15.64 5.35003C15.84 5.16003 15.84 4.84003 15.65 4.65003Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-model-training`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconModelTraining

    ```js
    <b-new-b-icon-model-training />
    ```
</docs>


